var map = {
	"./avatar_1.svg": "9347",
	"./avatar_10.svg": "8ce9",
	"./avatar_11.svg": "0846",
	"./avatar_12.svg": "5975",
	"./avatar_13.svg": "ac15",
	"./avatar_14.svg": "f236",
	"./avatar_15.svg": "a930",
	"./avatar_16.svg": "77ee",
	"./avatar_17.svg": "909d",
	"./avatar_18.svg": "0845",
	"./avatar_19.svg": "f9eb",
	"./avatar_2.svg": "f890",
	"./avatar_20.svg": "5ce0",
	"./avatar_21.svg": "a4da",
	"./avatar_22.svg": "33c1",
	"./avatar_23.svg": "d0ef",
	"./avatar_24.svg": "df0e",
	"./avatar_25.svg": "eb16",
	"./avatar_26.svg": "c059",
	"./avatar_27.svg": "5356",
	"./avatar_28.svg": "dd13",
	"./avatar_29.svg": "5b34",
	"./avatar_3.svg": "4c0c",
	"./avatar_30.svg": "3c9c",
	"./avatar_31.svg": "3d59",
	"./avatar_32.svg": "89d0",
	"./avatar_33.svg": "685c",
	"./avatar_34.svg": "9889",
	"./avatar_35.svg": "d446",
	"./avatar_36.svg": "0c3c",
	"./avatar_37.svg": "1826",
	"./avatar_38.svg": "10c8",
	"./avatar_39.svg": "c16b",
	"./avatar_4.svg": "29e6",
	"./avatar_40.svg": "e043",
	"./avatar_41.svg": "03b0",
	"./avatar_42.svg": "a3d4",
	"./avatar_43.svg": "fd7a",
	"./avatar_44.svg": "38b0",
	"./avatar_45.svg": "40ed",
	"./avatar_5.svg": "02a2",
	"./avatar_6.svg": "ee11",
	"./avatar_7.svg": "eab2",
	"./avatar_8.svg": "6e41",
	"./avatar_9.svg": "d828",
	"./avatar_larry.svg": "3632"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8085";